module.exports = __webpack_public_path__ + "assets/successNote1Icon-029f4f.svg";